import React from 'react';

function LocationConfirmModal({ onConfirm, onCancel, locationType = 'current' }) {
  const getLocationText = () => {
    switch (locationType) {
      case 'current':
        return 'your current GPS location';
      case 'address':
        return 'the address you entered';
      case 'map':
        return 'the location you clicked on the map';
      default:
        return 'this location';
    }
  };

  return (
    <div className="auth-overlay" onClick={onCancel}>
      <div className="auth-modal-wrapper" onClick={(e) => e.stopPropagation()}>
        <div className="auth-modal location-confirm-modal">
          <h2>📍 Confirm Location Sharing</h2>
          
          <div className="location-confirm-content">
            <p>
              <strong>You are about to share {getLocationText()} publicly on the map.</strong>
            </p>
            
            <div className="location-warning">
              <div className="warning-icon">⚠️</div>
              <div className="warning-text">
                <p>This will:</p>
                <ul>
                  <li>Make your food truck location visible to all app users</li>
                  <li>Display your truck name and Instagram handle publicly</li>
                  <li>Allow customers to find and get directions to your location</li>
                  <li>Replace any previously pinned location</li>
                </ul>
              </div>
            </div>

            <p className="privacy-note">
              <strong>Privacy Note:</strong> Your exact address won't be shared - only the general location pin on the map. You can remove your location at any time.
            </p>
          </div>

          <div className="auth-buttons location-confirm-buttons">
            <button 
              type="button" 
              onClick={onCancel}
              className="auth-button secondary"
            >
              Cancel
            </button>
            <button 
              type="button" 
              onClick={onConfirm}
              className="auth-button primary"
            >
              📍 Share My Location
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LocationConfirmModal;